import { useEffect, useState } from "react";
import { DocumentModel } from "../../../model/DocumentModel";
import { useDisclosure } from "@mantine/hooks";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
    Box,
    Grid,
    LoadingOverlay,
    TextInput,
    Checkbox,
    Button,
    Textarea,
} from "@mantine/core";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { repositorySign } from "../../../_base/_const/_constVar";
const DocTypeCreateView = ({ onClose }: DocTypeCreateViewProps) => {
    const [entity, setEntity] = useState<DocumentModel>({
        id: 0,
        code: null,
        name: null,
        description: null,
        active: false,
        createBy: null,
        lastUpdateBy: null,
        createDate: null,
        lastUpdateDate: null,
    });
    const [visible, { close, open }] = useDisclosure(false);

    const form = useForm<DocumentModel>({
        mode: "uncontrolled",
        validateInputOnChange: true,
        initialValues: {
            ...entity,
        },
        transformValues: (values) => ({
            ...values,
        }),
        validate: {
            code: (value) => {
                if (!value) {
                    return "Vui lòng nhập mã loại tài liệu!";
                }
                return null;
            },
            name: (value) => {
                if (!value) {
                    return "Vui lòng nhập tên loại tài liệu!";
                }
                return null;
            },
        },
    });

    const handleSetEntity = async () => {
        const res = await fetch(
            "https://apis-pos-dev.hacom.vn/api-sign/api/v1/TblDocType/create",
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            }
        );
        const data = (await res.json()) as MessageResponse<DocumentModel>;
        console.log(data.data);

        if (data && data.success) {
            setEntity(data.data);
        } else {
            NotificationExtension.Fails("Lỗi !");
        }
    };

    const handleCreateTblDocType = async (payload: DocumentModel) => {
        open();
        let url =
            "https://apis-pos-dev.hacom.vn/api-sign/api/v1/TblDocType/create";

        const response = await repositorySign.post<
            MessageResponse<DocumentModel>
        >(url, payload);

        if (response && response.success) {
            onClose((prev: any) => !prev);
            modals.closeAll();
            NotificationExtension.Success("Tạo loại tài liệu thành công !");
        } else {
            NotificationExtension.Fails("Tạo loại tài liệu thất bại !");
        }
        close();
    };

    useEffect(() => {
        handleSetEntity();
    }, []);

    return (
        <>
            <Box
                component="form"
                mx="auto"
                px="10px"
                onSubmit={form.onSubmit((e: DocumentModel) => {
                    handleCreateTblDocType(e);
                })}
                style={{
                    position: "relative",
                }}
            >
                <LoadingOverlay
                    visible={visible}
                    zIndex={1000}
                    overlayProps={{ radius: "sm", blur: 2 }}
                />

                <Grid>
                    <Grid.Col span={12}>
                        <TextInput
                            label="Mã loại tài liệu"
                            placeholder="Nhập mã loại tài liệu"
                            {...form.getInputProps("code")}
                        />
                    </Grid.Col>

                    <Grid.Col span={12}>
                        <TextInput
                            label="Tên loại tài liệu"
                            placeholder="Nhập tên loại tài liệu"
                            {...form.getInputProps("name")}
                        />
                    </Grid.Col>

                    <Grid.Col span={12}>
                        <Textarea
                            label="Tên loại tài liệu"
                            placeholder="Nhập tên loại tài liệu"
                            {...form.getInputProps("description")}
                        />
                    </Grid.Col>

                    <Grid.Col span={12}>
                        <Checkbox
                            label="Sử dụng"
                            {...form.getInputProps("active")}
                        ></Checkbox>
                    </Grid.Col>
                </Grid>

                <Grid>
                    <Grid.Col
                        span={12}
                        display={"flex"}
                        style={{ justifyContent: "flex-end", gap: "40px" }}
                    >
                        <Button
                            type="button"
                            color="gray"
                            loading={visible}
                            onClick={() => {
                                modals.closeAll();
                            }}
                            leftSection={
                                !visible ? <IconWindow size={18} /> : undefined
                            }
                        >
                            Đóng
                        </Button>
                        <Button
                            type="submit"
                            color="blue"
                            loading={visible}
                            leftSection={
                                !visible ? <IconCheck size={18} /> : undefined
                            }
                        >
                            Lưu
                        </Button>
                    </Grid.Col>
                </Grid>
            </Box>
        </>
    );
};

type DocTypeCreateViewProps = {
    onClose: any;
};
export default DocTypeCreateView;
